module.exports = __webpack_public_path__ + "img/top1.0495f618.png";